import { Flex, Text } from "@chakra-ui/react";

export default function InfoCardsDetalhamento({ title, array }: any) {
  return (
    <Flex w={"100%"} flexDir={"column"} my={2}>
      <Text fontWeight={"bold"} my={2}>
        {title}
      </Text>
      {array &&
        array.map((item: any, index: any) => {
          return (
            <Flex flexDir={"row"} justifyContent="space-between" key={index} w={"100%"}>
              <Text mr={2} fontWeight={"500"} w={"50%"}>
                {item.titulo}
              </Text>
              <Text w={"50%"}>{item.valor}</Text>
            </Flex>
          );
        })}
    </Flex>
  );
}
